/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_Note_StrongInputs */

const en_us2_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app takes this into account when it adjusts your next workouts.`)
};

const pt_br2_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O app leva isso em conta ao ajustar seus próximos treinos.`)
};

const es_419_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La app lo tiene en cuenta al ajustar tus próximos entrenamientos.`)
};

const pt_pt2_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A app tem isto em conta ao ajustar os teus próximos treinos.`)
};

const fr_fr2_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'appli en tient compte pour ajuster tes prochaines séances.`)
};

const de_de2_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die App berücksichtigt das, wenn sie deine nächsten Trainings anpasst.`)
};

const it_it2_today_checkin_note_strong = /** @type {(inputs: Today_Checkin_Note_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app ne tiene conto quando adatta i tuoi prossimi allenamenti.`)
};

/**
* | output |
* | --- |
* | "The app takes this into account when it adjusts your next workouts." |
*
* @param {Today_Checkin_Note_StrongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_note_strong = /** @type {((inputs?: Today_Checkin_Note_StrongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Note_StrongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_note_strong(inputs)
	if (locale === "es-419") return es_419_today_checkin_note_strong(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_note_strong(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_note_strong(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_note_strong(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_note_strong(inputs)
	return en_us2_today_checkin_note_strong(inputs)
});
export { today_checkin_note_strong as "today.checkin_note_strong" }